import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import LightbulbIcon from '@mui/icons-material/Lightbulb';

const WelcomeSuggestions = React.memo(({ suggestions, onSuggestionClick }) => {
  return (
    <Box sx={{ 
      textAlign: 'center', 
      mt: '200px',
      px: 2,
      maxWidth: '680px',
      mx: 'auto',
      animation: 'fadeIn 0.5s ease',
      '@keyframes fadeIn': {
        '0%': { opacity: 0, transform: 'translateY(20px)' },
        '100%': { opacity: 1, transform: 'translateY(0)' }
      }
    }}>
      <LightbulbIcon sx={{ 
        fontSize: 60, 
        color: 'primary.main', 
        mb: 2,
        filter: 'drop-shadow(0 4px 8px rgba(0, 150, 255, 0.3))'
      }} />
      
      <Typography variant="h5" gutterBottom sx={{ 
        fontWeight: 600, 
        color: 'text.primary',
        letterSpacing: '-0.5px',
        mb: 3
      }}>
        What would you like to explore?
      </Typography>
      
      <Box sx={{
        display: 'grid',
        gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' },
        gap: 2,
        maxWidth: '600px',
        mx: 'auto'
      }}>
        {suggestions.map((prompt, index) => (
          <Paper
            key={index}
            onClick={() => onSuggestionClick(prompt)}
            sx={{
              p: 2,
              cursor: 'pointer',
              border: '1px solid',
              borderColor: 'divider',
              bgcolor: 'background.paper',
              transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
              '&:hover': {
                transform: 'translateY(-2px)',
                borderColor: 'primary.main',
                boxShadow: 3,
                bgcolor: 'background.default'
              },
              borderRadius: 3,
            }}
          >
            <Typography variant="body2" sx={{
              color: 'text.primary',
              fontWeight: 500,
              textAlign: 'center'
            }}>
              {prompt}
            </Typography>
          </Paper>
        ))}
      </Box>
    </Box>
  );
});

export default WelcomeSuggestions; 